export default function getRawImages(images) {
    if (!images || images.length <= 0) {
        return [];
    }

    return images.map(item => item.split("@!")[0]);
}